import { useRef, useSyncExternalStore } from 'react';

function getSnapshot() {
  if ('fonts' in document) {
    return document.fonts.status;
  }
  return 'loaded';
}

function getServerSnapshot() {
  return 'loaded';
}

function subscribe(callback: () => void) {
  if ('fonts' in document) {
    document.fonts.onloading = callback;
    document.fonts.onloadingerror = callback;
    document.fonts.onloadingdone = callback;
  }

  return () => {
    if ('fonts' in document) {
      document.fonts.onloading = null;
      document.fonts.onloadingerror = null;
      document.fonts.onloadingdone = null;
    }
  };
}

/**
 * Hook that checks if the initially loaded fonts were updated.
 * Used to trigger remeasuring in the DataTable (autoWidth) and TextEllipsis once all fonts are loaded.
 *
 * @param callback - optionally pass a function to be executed once when the fonts were updated
 * @returns boolean whether the fonts have changed
 * @internal
 */
export function useFontsUpdated(callback?: () => void): void {
  const prevLoaded = useRef('loading');
  const loading = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );

  if (prevLoaded.current === 'loading' && loading === 'loaded') {
    callback?.();
  }
  prevLoaded.current = loading;
}
